module.exports = __webpack_public_path__ + "static/media/clear-all.585068b7.svg";